import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-fus-contabilidad',
  templateUrl: './fus-contabilidad.component.html',
  styles: [],
  providers: [FusService, ReversionService]
})
export class FusContabilidadComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  tipo_agregacion_id: number = 1;
  fusId: number = 0;
  nroFus: string;
  fuses: any[];
  fus: any;
  dataSeg: any[];
  popupVisibleSeg: boolean = false;
  fusSeg: string = '';
  fusEdit: any;
  estadosFilter: any = [];
  estado: number = 16;
  popupVisibleO: boolean = false;
  model: any;
  estados: any[] = [{ id: 3, descripcion: 'Observado' }, { id: 4, descripcion: 'Aprobado' }];
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  fechaRM = new Date();
  jusReversion = false;
  hasError: any;
  popupVisibleAnularPagos: boolean;
  rol: string = '';
  user_id: number =0;
  constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService) {
    this.getEstadosByUsuario();
    this.resetErrors();
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.user_id = u.id;
    this.tipo_agregacion_id= u.tipo_agregacion_id;    
  }

  ngOnInit() {
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListFus(this.estado, this.tipo_agregacion_id);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListFus(id: number, tipo_agregacion_id: number) {
    
    this._fs.getListFusByEstadoId(id, tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.fuses = result.data; }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          text: 'Actualizar',
          onClick: this.refreshDataGrid.bind(this)
        }
      });
  }

  refreshDataGrid(e) {
    this.getListFus(e.value, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
    this.estado = e.value;
  }

  observarFUS() {
    if (this.validObs()) {
      this.clicked = true;
      this._fs.putFusObservaPtto(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleO = false;
        });
    }
  }



  validObs() {
    let res = true;
    if (!UtilHelper.validator(this.model.observacion, 'text')) {
      this.hasError.observacion = true; res = false;
    }
    return res;
  }

  resetErrors() {
    this.model = { id: 0, nroC31: '', fechaC31: '', montoC31: '', observacion: '', fuses: [], file: null };
    this.hasError = { nroC31: false, fechaC31: false, montoC31: false, observacion: false, file: false };
  }

  showModalObs(id: number) {
    this.resetErrors();
    this.popupVisibleO = true;
    this.model.id = id;
  }



  getFusByNroFusC31(nroFusV: string) {
    this.nroFus = nroFusV;
    if (this.nroFus.length > 2) {
      this._fs.getFusAllByEstadoNroFUSC31(this.nroFus).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.fuses = result.data; }
          else { this.fuses = []; }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalAnularpagos(id: number) {
    this.fusId = id;
    this.popupVisibleAnularPagos = true;
  }

  anularPagos() {        
    this._rs.anularFusPagoReversion(this.fusId, this.user_id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAnularPagos = false;
          this.getListFus(this.estado, this.tipo_agregacion_id);
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalSeg(id: string, fus: string) {
    this.fusSeg = fus;
    this._fs.getSeguimientoByFusId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.dataSeg = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }


}
